///
/// EarthBrowser
///
/// Aurora legend body: what the glow's brightness and colors mean. The
/// emission colors mirror cGreen / cRed / cViolet and the altitude
/// profile in shaders/aurora_volume.glsl.
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

import { ColorScale, LegendFootnote, LegendSection, SymbolRow } from "./LegendPrimitives"

// Emission colors from aurora_volume.glsl, as drawn (additive, so these
// are the authored tints rather than a screen sample)
const cGreenCss = "rgb(77, 255, 115)"
const cRedCss = "rgb(255, 64, 102)"
const cVioletCss = "rgb(140, 89, 255)"

// Probability reads as brightness of the green curtains
const cProbabilityGradient = `linear-gradient(to right, rgba(77, 255, 115, 0) 0%, rgba(77, 255, 115, 0.35) 40%, ${cGreenCss} 100%)`
const cProbabilityTicks = [
	{ at: 0, label: "Unlikely" },
	{ at: 100, label: "Likely" },
]

function GlowSwatch({ color }: { color: string }) {
	return (
		<span
			className="w-7 h-3 rounded-sm"
			style={{ background: `linear-gradient(to top, ${color}, transparent)`, boxShadow: `0 0 6px ${color}` }}
		/>
	)
}

export function AuroraLegendContent() {
	return (
		<>
			<ColorScale label="Brightness · chance of aurora" gradient={cProbabilityGradient} ticks={cProbabilityTicks} />
			<LegendSection>
				<SymbolRow swatch={<GlowSwatch color={cGreenCss} />}>Green · oxygen, 100–150 km</SymbolRow>
				<SymbolRow swatch={<GlowSwatch color={cRedCss} />}>Red · high oxygen, 200–300 km, strong displays</SymbolRow>
				<SymbolRow swatch={<GlowSwatch color={cVioletCss} />}>Violet · nitrogen fringe at the base of strong curtains</SymbolRow>
			</LegendSection>
			<LegendFootnote>
				NOAA SWPC OVATION 30-minute forecast, 5-minute frames. Drawn on the night side only; look from orbit, the limb or the ground under it.
			</LegendFootnote>
		</>
	)
}
